module.exports = __webpack_public_path__ + "img/noti-warning.5a5b6fa8.svg";